import React from "react"
import propTypes from "prop-types"

import Link from "../utils/link"

import Instagram from "./HeaderIcons/Instagram"
import Search from "./HeaderIcons/Search"
import Hamburger from "./HeaderIcons/Hamburger"
import Cart from "./HeaderIcons/Cart"
import CartPopup from "./CartPopup"
import SubscribeNewsletterForm from "./SubscribeNewsletterForm"
import SearchPopup from "./SearchPopup"

import logoDark from "../assets/images/Icons/logo-dark-large.svg"
import logoLight from "../assets/images/Icons/logo-light-large.svg"
import logoFlyout from "../assets/images/Icons/logo-light.svg"
import menuClose from "../assets/images/Icons/menu-close.svg"
import "./header.scss"

const Header = ({
  checkout,
  isCartOpen,
  pathname,
  setIsCartOpen,
  socialPost,
  headerPost,
  updateQuantityInCart,
}) => {
  const [isVisible, setIsVisible] = React.useState(false)
  const [fillColor, setFillColor] = React.useState("dark")
  const [query, setQuery] = React.useState("")
  const [isSearchVisible, setIsSearchVisible] = React.useState(false)
  const [isSearchBoxVisible, setIsSearchBoxVisible] = React.useState(false)

  const pathsInWhite = [
    "/",
    "/shop",
    "/shop/",
    "/about",
    "/about/",
    "/subscription",
    "/subscription/",
    "/blog-article",
    "/blog-article/",
    "/be-better",
    "/be-better/",
  ]

  const toggleIsVisible = () => {
    setIsVisible(!isVisible)
  }

  const linksBottom = [
    {
      name: "privacy policy",
      link: "/privacy-policy/",
    },
    {
      name: "returns",
      link: "/returns/",
    },
    {
      name: "shipping + returns",
      link: "/delivery-details/",
    },
    {
      name: "terms & conditions",
      link: "/terms-of-service/",
    },
  ]

  const reload = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  const handleKeyPress = (event) => {
    if (event.keyCode === 13) {
      window.location.href = `/search?q=${query}`
    }
  }
  React.useEffect(() => {
    const rootElement = document.querySelector(":root")

    const logo = document.querySelector(".header__container__nav__logo")

    if (pathname !== "/") {
      logo.classList.remove("header__container__nav__logo--home")
    } else {
      logo.classList.add("header__container__nav__logo--home")
    }
    if (pathsInWhite.includes(pathname)) {
      setFillColor("light")
      rootElement.style.setProperty("--color-header-font", "#ffffff")
      rootElement.style.setProperty("--color-header-background", "#526e3e")
    } else {
      setFillColor("dark")
      rootElement.style.setProperty("--color-header-font", "#526e3e")
      rootElement.style.setProperty("--color-header-background", "#ffffff")
    }

    if (typeof window !== "undefined") {
      window.onload = setTimeout(function () {
        logo.classList.add("show")
      }, 1000)
    }

    const LogoAnimation = () => {
      const animatedLogo = document.querySelector(
        ".header__container__nav__logo--home"
      )
      if (animatedLogo) {
        const halfWindowHeight = window.innerHeight / 4
        if (window.scrollY > halfWindowHeight) {
          animatedLogo.style.position = "fixed"
          animatedLogo.style.width = "var(--logo-width-small)"
          animatedLogo.style.top = "25px"
        } else {
          animatedLogo.style.position = "absolute"
          animatedLogo.style.width = "var(--logo-width-big)"
          animatedLogo.style.top = "40vh"
          animatedLogo.style.display = "block"
        }
      }
    }

    if (pathname === "/") {
      logo.style.position = "absolute"
      logo.style.width = "var(--logo-width-big)"
      logo.style.top = "40vh"
      logo.style.display = "block"
      window.addEventListener("scroll", LogoAnimation)
    } else {
      logo.style.position = "fixed"
      logo.style.width = "var(--logo-width-small)"
      logo.style.top = "25px"
      logo.style.display = "block"
    }
  }, [pathname])

  React.useEffect(() => {
    const popupOpened = () => {
      document.body.style.overflowY = "hidden"
      const logo = document.querySelector(".header__container__nav__logo")
      if (logo) logo.style.zIndex = "1"
    }

    const popupClosed = () => {
      document.body.style.overflowY = "visible"
      document.querySelector(".header__container__nav__logo").style.zIndex = "2"
    }

    isCartOpen || isVisible || isSearchVisible ? popupOpened() : popupClosed()
  }, [isCartOpen, isVisible, isSearchVisible])

  React.useEffect(() => {
    const headerBackground = () => {
      const headerElement = document.querySelector(".header")
      const halfWindowHeight = window.innerHeight / 4

      if (window.scrollY > halfWindowHeight) {
        headerElement.style.backgroundColor = "var(--color-header-background)"
      } else {
        headerElement.style.backgroundColor = "transparent"
      }
    }

    window.addEventListener("scroll", headerBackground)
  }, [])

  React.useEffect(() => {
    const rootElement = document.querySelector(":root")
    if (window.innerWidth < 900) {
      rootElement.style.setProperty("--logo-width-small", "69px")
      rootElement.style.setProperty("--logo-width-big", "250px")
    } else {
      rootElement.style.setProperty("--logo-width-small", "92px")
      rootElement.style.setProperty("--logo-width-big", "417px")
    }
  }, [])

  const openDropdown = (count, subLinksPresent) => {
    const dropDown = document.querySelectorAll(".popover")

    dropDown[count].style.display = "block"

    if (subLinksPresent)
      document
        .querySelector(":root")
        .style.setProperty("--color-dropdown", "#f59bbb")
  }

  const closeDropdown = (count) => {
    const dropDown = document.querySelectorAll(".popover")

    dropDown[count].style.display = "none"

    document
      .querySelector(":root")
      .style.setProperty("--color-dropdown", "transparent")
  }

  return (
    <div>
      <header className="header">
        {/* <p
          className={`header__announcement ${
            isVisible ? "header__announcement--hidden" : ""
          } `}
        >
          Free shipping on orders over &#36;30
        </p> */}

        <div
          className={`header__container ${
            isVisible ? "header__container--flyout" : ""
          }`}
        >
          <nav className="header__container__nav">
            <div
              onClick={toggleIsVisible}
              className="header__container__nav__hamburger"
            >
              <Hamburger
                fill={isVisible ? "#ffffff" : "var(--color-header-font)"}
              />
            </div>
           {headerPost && headerPost.acf && (
              <ul className="header__container__nav__links">
                {headerPost.acf.headerLinks.map((link, index) => {
                  return (
                    <li
                      onClick={reload}
                      key={index}
                      className={"popover-link"}
                      onMouseEnter={() =>
                        openDropdown(index, link.subLinksPresent)
                      }
                      onMouseLeave={() => closeDropdown(index)}
                    >
                      <Link
                        to={link.link}
                        title={link.name}
                        className={`header__container__nav__links__link`}
                        onClick={isVisible ? toggleIsVisible : null}
                      >
                        {link.name}
                      </Link>

                      <div className="popover">
                        {link.subLinksPresent &&
                          link.subLinks.map((sublink) => {
                            return (
                              <div key={sublink.name}>
                                <Link to={sublink.link}>{sublink.name}</Link>
                              </div>
                            )
                          })}
                      </div>
                    </li>
                  )
                })}
              </ul>
            )}

            {isSearchBoxVisible && (
              <input
                type="text"
                className="header__container__nav__search-input"
                value={query}
                onKeyUp={handleKeyPress}
                onChange={(e) => setQuery(e.target.value)}
                autoFocus
              />
            )}

            <ul className="header__container__nav__icons">
              <li>
                {!isVisible && (
                  <div
                    className="header__container__nav__icons__search "
                    onClick={() => {
                      window.innerWidth < 901
                        ? setIsSearchVisible(true)
                        : setIsSearchBoxVisible(!isSearchBoxVisible)
                    }}
                  >
                    <Search />
                  </div>
                )}
              </li>

              {socialPost && (
                <li className="header__container__nav__icons__instagram">
                  <Link
                    to={socialPost.socialMediaLinks.instagram}
                    target="_blank"
                    title="instagram"
                  >
                    <Instagram />
                  </Link>
                </li>
              )}

              <li
                onClick={() => {
                  setIsCartOpen(true)
                }}
                className={`header__container__nav__icons__cart ${
                  isVisible ? "header__container__nav__icons__cart--hidden" : ""
                }`}
              >
                <Cart />
              </li>

              <li
                className={`header__container__nav__icons__menu ${
                  isVisible
                    ? "header__container__nav__icons__menu--visible"
                    : ""
                }`}
                onClick={toggleIsVisible}
              >
                <img src={menuClose} />
              </li>
            </ul>

            <div
              className={`header__container__nav__bottom ${
                isVisible ? "header__container__nav__bottom--flyout" : " "
              }`}
            >
              {headerPost && headerPost.acf && (
                <ul className="header__container__nav__bottom__page-links">
                  {headerPost.acf.headerLinks.map((link, index) => {
                    return (
                      <div key={index}>
                        <li onClick={reload}>
                          <Link
                            to={link.link}
                            title={link.name}
                            className={`header__container__nav__bottom__page-links__link `}
                            onClick={isVisible ? toggleIsVisible : null}
                          >
                            {link.name}
                          </Link>
                        </li>
                        {link.subLinksPresent &&
                          link.subLinks.map((sublink) => {
                            return (
                              <li
                                onClick={reload}
                                key={sublink.name}
                                className="header__container__nav__bottom__page-links__sub-link"
                              >
                                <Link
                                  to={sublink.link}
                                  title={link.name}
                                  className="header__container__nav__bottom__page-links__link header__container__nav__bottom__page-links__link--sub-link"
                                  onClick={isVisible ? toggleIsVisible : null}
                                >
                                  {sublink.name}
                                </Link>
                              </li>
                            )
                          })}
                      </div>
                    )
                  })}
                </ul>
              )}
              <div>
                <ul className="header__container__nav__bottom__links">
                  {linksBottom.map((link, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to={link.link}
                          title={link.name}
                          className="header__container__nav__bottom__links__link"
                          onClick={isVisible ? toggleIsVisible : null}
                        >
                          {link.name}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
                <div className="header__container__nav__bottom__form">
                  <SubscribeNewsletterForm />
                </div>
                <p className="header__container__nav__bottom__copyrights  ">
                  &#169;Copyright ROCC Naturals 2020.
                </p>
              </div>
            </div>
          </nav>
        </div>

        {isCartOpen && (
          <CartPopup
            setIsCartOpen={setIsCartOpen}
            checkout={checkout}
            updateQuantityInCart={updateQuantityInCart}
          />
        )}

        <div className="search-model">
          {isSearchVisible && (
            <SearchPopup
              setIsSearchVisible={setIsSearchVisible}
              handleKeyPress={handleKeyPress}
              setQuery={setQuery}
              query={query}
            />
          )}
        </div>
      </header>

      {isVisible ? (
        <Link
          to="/"
          title="ROCC"
          className="header__container__nav__logo--flyout"
        >
          <img src={logoFlyout} onClick={isVisible ? toggleIsVisible : null} />
        </Link>
      ) : (
        <Link
          to="/"
          title="ROCC"
          onClick={reload}
          className="header__container__nav__logo header__container__nav__logo--home"
        >
          <img
            src={fillColor === "dark" ? logoDark : logoLight}
            onClick={isVisible ? toggleIsVisible : null}
          />
        </Link>
      )}
    </div>
  )
}

Header.propTypes = {
  pathname: propTypes.string.isRequired,
  checkout: propTypes.object.isRequired,
  data: propTypes.object,
  instagram: propTypes.string,
  isCartOpen: propTypes.bool.isRequired,
  headerPost: propTypes.object.isRequired,
  setIsCartOpen: propTypes.func.isRequired,
  socialPost: propTypes.object.isRequired,
  updateQuantityInCart: propTypes.func.isRequired,
}

export default Header
